import React, {Component} from 'react';
import {
    Image,
    Container,
    Header
} from 'semantic-ui-react';
import update from 'react-addons-update';

import StoreProfileData from "../../data/StoreProfileData";
import {showToast} from "../../actions/ToastAction";
import {connect} from "react-redux";
import Loading from "../extras/Loading";

const logo = require('../../img/logo_text1.svg');

class Logo extends Component {

    constructor() {
        super();

        this.state = {
            data: {
                logo: '',
            },
            loading: true
        };

        this.handleChangeLogo = this.handleChangeLogo.bind(this);
        this.handleLogoChange = this.handleLogoChange.bind(this);
    }

    componentWillMount() {
        this.initialFetch();
    }

    handleChangeLogo = () => {
        this.refs.fileUploadLogo.click();
    };

    async initialFetch() {
        const data = await StoreProfileData.getLogo();
        if(data.logo_url){
            data['logo_url'] = data.logo_url + '?tr=w-300,ar-16-9'
        }
        this.setState({data, loading:false});
    }

    handleLogoChange(e) {
        let reader = new FileReader();
        let file = e.target.files[0];
        reader.onloadend = () => {
            let logo_url = update(this.state, {
                data: {
                    logo_url: {$set: reader.result},
                }
            });
            this.setState(logo_url);
            StoreProfileData.changeLogo({picture: this.state.data.logo_url}, () => {
                this.props.showToast({message:'Logo Actualizado!', type:'success'});
            });
        };
        
        if(file){
            reader.readAsDataURL(file)
        }
    }

    render() {
        return (
            <Container>
                <Header as='h2'>
                    <Header.Content>
                        Logo
                    </Header.Content>
                </Header>

                {!this.state.loading ?<div>
                    <input
                        ref="fileUploadLogo"
                        type="file"
                        style={{"display": "none"}}
                        accept=".png, .jpg, .jpeg"
                        onChange={this.handleLogoChange}
                    />
                    <Image onClick={this.handleChangeLogo} href='#' src={this.state.data.logo_url ? this.state.data.logo_url:logo} size='medium'
                           verticalAlign='middle'/>
                </div>:<Loading/>}
            </Container>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return {
        showToast(toast) {
            dispatch(showToast(toast))
        }
    }
}

export default connect(
    null,
    mapDispatchToProps
)(Logo)



// WEBPACK FOOTER //
// ./src/components/settings/Logo.js